const t = "_root_169hv_1", o = "_zapCard_169hv_17", a = "_withLargeImage_169hv_47", e = "_fullWidth_169hv_51", _ = "_responsive_169hv_56", n = "_small_169hv_63", s = "_large_169hv_68", r = "_topOfCard_169hv_79", c = "_imageContainer_169hv_89", i = "_withAppIcons_169hv_104", h = "_serviceIconWrapper_169hv_111", l = "_metadataWrapper_169hv_121", p = "_title_169hv_139", v = "_tag_169hv_203", g = "_tagIcons_169hv_210", d = "_tagText_169hv_217", m = "_hideOnMobile_169hv_222", C = "_skeletonRoot_169hv_230", I = "_bookmarkButtonContainer_169hv_235", b = "_tagLabel_169hv_247", k = {
  root: t,
  zapCard: o,
  withLargeImage: a,
  fullWidth: e,
  responsive: _,
  small: n,
  large: s,
  topOfCard: r,
  imageContainer: c,
  withAppIcons: i,
  serviceIconWrapper: h,
  metadataWrapper: l,
  title: p,
  tag: v,
  tagIcons: g,
  tagText: d,
  hideOnMobile: m,
  skeletonRoot: C,
  bookmarkButtonContainer: I,
  tagLabel: b
};
export {
  k as s
};
//# sourceMappingURL=TemplateCard.module-QDG2j1e4.mjs.map
